// environment.dev.ts
export const environment = {
  production: true,
  apiUrl: import.meta.env.NG_APP_API_URL || 'https://dev.api.enjochemagro.com/api/',
  wsUrl: import.meta.env.NG_APP_WS_URL || 'wss://dev.api.enjochemagro.com/ws/',
  envName: import.meta.env.NG_APP_ENV || 'development',
};
